module.exports = __webpack_public_path__ + "static/og-image-blog-a0c427c3cceca2f05c1efe5ec6161b8e.png";